import React from 'react';

import { Fab, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

export default function RMSAddButton(props) {
  const { tooltipText, onClick, required, disabled } = props;

  return (
    <Tooltip title={tooltipText || 'Add'}>
      <Fab
        disabled={disabled || false}
        color="secondary"
        style={{ marginLeft: '10px', background: required && '#d32f2f' }}
        size="small"
        aria-label="add">
        <AddIcon onClick={onClick} />
      </Fab>
    </Tooltip>
  );
}
